const env = window.__ENV || {};

const oktaConfig = {
  clientId: env.REACT_APP_OKTA_CLIENT_ID,
  issuer: `https://${env.REACT_APP_OKTA_DOMAIN}/`,
  redirectUri: window.location.origin + '/login/callback',
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
};
export default oktaConfig;
